import { useEffect, useRef } from 'react';

export const useEffectOnce = (
  effect: () => void | (() => void),
  dependencies: React.DependencyList = [],
): void => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
